import LayoutPadrao from 'lg-vue-components/layoutPadrao'
export default [
   {
      path: '/',
      redirect: 'indisponibilidades',
      component: LayoutPadrao,
      children: [
         {
            path: '/indisponibilidades',
            name: 'indisponibilidades',
            component: () => import('./pages/ListarIndisponibilidade.vue')
         }
      ]
   },
   {
      path: '/',
      redirect: 'indisponibilidades',
      component: LayoutPadrao,
      children: [
         {
            path: '/indisponibilidades/:id',
            name: 'indisponibilidades-editar',
            component: () => import('./pages/EditarIndisponibilidade.vue')
         }
      ]
   }
]
